import { render, staticRenderFns } from "./table-audit-task.vue?vue&type=template&id=fdca1f80&scoped=true&"
import script from "./table-audit-task.vue?vue&type=script&lang=js&"
export * from "./table-audit-task.vue?vue&type=script&lang=js&"
import style0 from "./table-audit-task.vue?vue&type=style&index=0&id=fdca1f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdca1f80",
  null
  
)

export default component.exports